var React = require('react');

function StatusExpectedInverted (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Expected"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M11.5,0A11.5,11.5,0,1,0,23,11.5,11.51,11.51,0,0,0,11.5,0","style":{"fill":"#fff","fillRule":"evenodd"},"key":0}),React.createElement("path",{"d":"M10.61,6.51v4.11H6.51a.89.89,0,0,0,0,1.77h4.1v4.1a.89.89,0,0,0,1.77,0v-4.1h4.11a.87.87,0,0,0,.88-.88h0a.9.9,0,0,0-.88-.89H12.38V6.51a.88.88,0,0,0-.92-.84A.9.9,0,0,0,10.61,6.51Z","style":{"fill":"#47cccd","fillRule":"evenodd"},"key":1})])]);
}

StatusExpectedInverted.defaultProps = {"role":"presentation","viewBox":"0 0 23 23"};

module.exports = StatusExpectedInverted;

StatusExpectedInverted.default = StatusExpectedInverted;
